import React from 'react';
import Reveal from './Reveal';
import './Biography.css';

const facets = [
  {
    title: 'O Sambista',
    text: 'Reconhecido pelo Sindicato Nacional dos Compositores, com 10 músicas no Palco MP3. Criou sambas marcantes como "Rio de Janeiro Cidade Maravilhosa" e "Barraco de Zinco", em parceria com Dudu Fagundes, Tarso de Paula e outros.'
  },
  {
    title: 'O Escultor',
    text: 'Autodidata que descobriu no barro a matéria-prima ideal para sua arte. Desenvolveu técnica própria ao longo de mais de 30 anos, com obras em tamanho natural, preparando agora sua primeira exposição oficial.'
  },
  {
    title: 'O Escritor & Poeta',
    text: 'Uma escrita que carrega lirismo e crítica social, com forte identidade cultural. Autor de poesias e de cinco roteiros de curta-metragem, foi capa da Revista Close Brazil (edição on-line 2025) como “o cantor que nunca desistiu”.'
  }
];

const timeline = [
  {
    year: 'Infância',
    title: 'Mirai, Minas Gerais — o berço',
    description: 'Filho de Sebastião Cesário e Antônia Varella, descobriu a paixão pela arte nos quintais da infância, embalado por Roberto Carlos e Fernando Mendes. A música já pulsava forte, levando-o a cantar em festas, praças, clubes e butecos.'
  },
  {
    year: 'Rio de Janeiro',
    title: 'A Cidade Maravilhosa — 10 anos',
    description: 'Durante 10 anos no Rio, encontrou na boêmia Lapa a inspiração para compor sambas como "Rio de Janeiro Cidade Maravilhosa", "Barraco de Zinco", "Forró da Bicharada" e "Malandragem". Sua trajetória musical ganhou força na capital carioca.'
  },
  {
    year: '1990',
    title: 'Barra Mansa — a descoberta do barro',
    description: 'Ao chegar a Barra Mansa, descobriu no barro a matéria ideal para expressar sua arte. Sua primeira obra — uma escultura em tamanho natural — impressionou a comunidade. Desenvolveu uma técnica própria, fruto de uma evolução criadora original.'
  },
  {
    year: 'Hoje',
    title: 'O artista plural',
    description: 'Antônio Varella, o Varella Sambista, é compositor, cantor, escritor, poeta e escultor. Uma trajetória marcada pela autenticidade e pela capacidade de transformar a vida em múltiplas formas de arte.'
  }
];

const influences = [
  'Roberto Carlos e Fernando Mendes',
  'Samba de raiz e samba-enredo',
  'Cultura popular mineira',
  'Boêmia da Lapa carioca',
  'Tradições afro-brasileiras',
  'Música popular brasileira'
];

const partnerships = [
  'Dudu Fagundes — Maestro das Ruas',
  'Carlos do Nascimento',
  'Adão, Maria',
  'Tarso de Paula',
  'Sindicato Nacional dos Compositores',
  'Comunidade Artística de Barra Mansa'
];

const Biography = () => {
  return (
    <section id="biography" className="biography section">
      <div className="container">
        <Reveal>
          <span className="section-eyebrow">A jornada do artista</span>
          <h2 className="section-title">Trajetória</h2>
          <p className="section-subtitle">
            Três faces de um mesmo coração artístico, costuradas por uma vida dedicada
            à cultura brasileira.
          </p>
        </Reveal>

        {/* As três faces */}
        <div className="facets-grid">
          {facets.map((f, i) => (
            <Reveal key={f.title} className="facet-card" delay={i * 90}>
              <span className="facet-index">0{i + 1}</span>
              <h3 className="facet-title">{f.title}</h3>
              <p className="facet-text">{f.text}</p>
            </Reveal>
          ))}
        </div>

        {/* Timeline + foto */}
        <div className="timeline-block">
          <div className="timeline">
            {timeline.map((item, index) => (
              <Reveal key={index} className="timeline-item" delay={index * 70}>
                <div className="timeline-marker"><span></span></div>
                <div className="timeline-content">
                  <span className="timeline-year">{item.year}</span>
                  <h3 className="timeline-title">{item.title}</h3>
                  <p className="timeline-description">{item.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="timeline-photo">
            <img
              src="/sentadoseriopraesquerda.png"
              alt="Varella Sambista sentado"
              width="408"
              height="612"
              loading="lazy"
            />
          </Reveal>
        </div>

        {/* Influências + parcerias */}
        <div className="bio-details">
          <Reveal className="detail-section">
            <h3 className="detail-heading">Influências</h3>
            <div className="tags-container">
              {influences.map((inf, i) => (
                <span key={i} className="influence-tag">{inf}</span>
              ))}
            </div>
          </Reveal>

          <Reveal className="detail-section" delay={90}>
            <h3 className="detail-heading">Parcerias &amp; Conexões</h3>
            <figure className="partnership-photo">
              <img
                src="/duduFagundes.jpg"
                alt="Varella com Dudu Fagundes, o Maestro das Ruas"
                width="645"
                height="484"
                loading="lazy"
              />
              <figcaption>Varella e Dudu Fagundes — Maestro das Ruas, na Lapa</figcaption>
            </figure>
            <div className="tags-container">
              {partnerships.map((p, i) => (
                <span key={i} className="partnership-tag">{p}</span>
              ))}
            </div>
          </Reveal>
        </div>

        {/* Citação */}
        <Reveal className="bio-quote">
          <blockquote>
            “Logo vi que dava pra fazer muita coisa com o barro molhado. Minha criatividade
            começou a fluir. A arte é a ponte que conecta a alma individual à alma coletiva,
            expressando a essência do que é ser brasileiro.”
          </blockquote>
          <cite>Antônio Varella — Varella Sambista</cite>
        </Reveal>

        {/* Currículo */}
        <Reveal className="curriculum">
          <h3 className="detail-heading curriculum-heading">Currículo Artístico</h3>
          <img
            src="/curriculumartistitco.jpg"
            alt="Currículo artístico de Varella Sambista"
            className="curriculum-image"
            width="927"
            height="1294"
            loading="lazy"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default Biography;
